var Curriculog = Curriculog || {};

Curriculog.StatusFilter = (function ($, _, Backbone, StatusFilter) {

	StatusFilter = Backbone.View.extend({

		el: function () {
			return $('.decision');
		},

		events: {},

		initialize: function(options) {
			this.params = options.params;
			this.defaultQueries = options.defaultQueries;
			this.listenTo(Backbone, 'dateType:changed', this.completed);
		},

		get: function() {
			this.select();
			this.disable();
		},

		select: function() {
			// populates the advanced filter select checkboxes to match the default
			// base query or the search in session
			var statusFilter = this.params.queryParams.get('status');
			$('input[id^="report-9-status"]:checked').attr('checked', false);
			_.each(statusFilter, function(element, index) {
				$('#report-9-status-' + element).attr('checked', true);
			});
		},

		disable: function(event) {
			// disables all status checkboxes that are not available by default in
			// the base query
			var allowedStatuses = this.defaultQueries[this.params.domParams.get('tab')].allowedStatuses();

			$('input[id^="report-9-status"]').attr('disabled', true);
			_.each(allowedStatuses, function(element, index) {
				$('#report-9-status-' + element).attr('disabled', false);
			});
		},

		set: function() {
			var statuses = $('input[id^="report-9-status"]:checked').map(function (k, v) {
					return $(v).attr('name').split('-').reverse()[0];
				}).get();
			this.params.queryParams.set('status', statuses);
		},

		completed: function() {
			$('#report-9-status-completed').attr('checked', true);
		}

	});

	return StatusFilter;

})($, _, Backbone, Curriculog.StatusFilter || {});